<template>
  <Row :gutter="16" style="height: 100%">
    <div class="ivu-select-dropdown" id="s3-file-row-rMenu" style="visibility: hidden">
      <ul class="ivu-dropdown-menu">
        <li class="ivu-dropdown-item" @click="rMenuClick('prv')"
            :class="{'u-disabled': path.index <= 0, 'active': path.index > 0}"><Icon type="md-arrow-round-back"/> 返回</li>
        <li class="ivu-dropdown-item" @click="rMenuClick('next')"
            :class="{'u-disabled': path.index >= path.history.length - 1, 'active': path.index < path.history.length - 1}"><Icon type="md-arrow-round-forward"/> 前进</li>
        <li class="ivu-dropdown-item" @click="rMenuClick('refresh')"><Icon type="md-refresh"/> 刷新</li>
        <li class="ivu-dropdown-item" @click="rMenuClick('tran')" style="color: #ff9900" v-if="currentRClickRow">同步到服务器</li>
        <!--<li class="ivu-dropdown-item" style="color: rgb(237, 64, 20);">删除</li>-->
      </ul>
    </div>
    <Modal title="执行结果" v-model="execHistoryResultModal" width="900">
      <Spin fix v-if="execHistoryResultLoading"></Spin>
      <Alert show-icon type="error" v-else-if="execHistoryResultErrMsg">{{ execHistoryResultErrMsg }}</Alert>
      <div v-else>
        <pre class="exec-history-result" :style="{color: execHistoryResult.code === 200 ? '#19be6b': '#ed4014'}">{{ execHistoryResult.result }}</pre>
      </div>
      <div slot="footer">
        <Button @click="execHistoryResultModal = false" style="margin-left: 8px">关闭</Button>
      </div>
    </Modal>
    <Alert :type="message.type" show-icon style="margin: 0 8px" v-if="message.show">{{ message.content }}<a style="float: right" v-on:click="message.show = false">关闭</a></Alert>
    <Collapse simple class="transport-list-collapse" v-model="transportQueue.show" accordion>
      <Panel name="transport_list">
        传输列表
        <div slot="content">
          <List size="small" :loading="transportQueue.loading">
            <div style="max-height: 100px; overflow:auto;">
              <ListItem v-for="(item, id) in transportQueue.transporting" :key="id">
                <span>队列 {{ id }}</span>
                <Divider type="vertical" class="transport-list-divider"></Divider>
                <span v-if="item.started">
                  <span>{{ moment(item.started).format('YYYY-MM-DD HH:mm:ss') }}</span>
                  <Divider type="vertical" class="transport-list-divider"></Divider>
                </span>
                <span>{{ item.model_verbose }}</span>
                <Divider type="vertical" class="transport-list-divider"></Divider>
                <!-- <span>{{ item.hostname }}</span> -->
                <Divider type="vertical" class="transport-list-divider"></Divider>
                <span>{{ item.source }} ({{ item.params }}) </span>
                <span style="margin: 0 10px">-></span>
                <span>{{ item.target }} ({{ item.bucket }})</span>
                <!-- <span>{{ item.params }}</span> -->
                <Divider type="vertical" class="transport-list-divider"></Divider>
                <Progress :percent="30" :stroke-color="['#108ee9', '#87d068']" status="active" style="width: 100px;"/>
              </ListItem>
              <ListItem v-for="(item, id) in transportQueue.queue" :key="id">
                <span>队列 {{ id }}</span>
                <Divider type="vertical" class="transport-list-divider"></Divider>
                <span v-if="item.started">
                  <span>{{ moment(item.started).format('YYYY-MM-DD HH:mm:ss') }}</span>
                  <Divider type="vertical" class="transport-list-divider"></Divider>
                </span>
                <span>{{ item.model_verbose }}</span>
                <Divider type="vertical" class="transport-list-divider"></Divider>
                <span>{{ item.source }} ({{ item.params }}) </span>
                <span style="margin: 0 10px">-></span>
                <span>{{ item.target }} ({{ item.bucket }})</span>
                <Divider type="vertical" class="transport-list-divider"></Divider>
                <span style="color: #2D8cF0"><Icon type="ios-time-outline" size="16" /> {{ item.status }}</span>
              </ListItem>
              <ListItem v-for="(item, id) in transportQueue.ended" :key="id">
                <span>队列 {{ id }}</span>
                <Divider type="vertical" class="transport-list-divider"></Divider>
                <span v-if="item.started">
                  <span>{{ moment(item.started).format('YYYY-MM-DD HH:mm:ss') }}</span>
                  <Divider type="vertical" class="transport-list-divider"></Divider>
                </span>
                <span>{{ item.model_verbose }}</span>
                <Divider type="vertical" class="transport-list-divider"></Divider>
               <span>{{ item.source }} ({{ item.params }}) </span>
                <span style="margin: 0 10px">-></span>
                <span>{{ item.target }} ({{ item.bucket }})</span>
                <Divider type="vertical" class="transport-list-divider"></Divider>
                <!-- <a v-on:click="openResultModal(item.id)">结果</a> -->
                <Divider type="vertical" class="transport-list-divider"></Divider>
                <Progress :percent="0" style="width: 100px" status="wrong" v-if="item.status !== '完成'" />
                <Progress :percent="100" :stroke-color="['#108ee9', '#87d068']" style="width: 100px" status="success" v-else/>
              </ListItem>
            </div>
          </List>
        </div>
      </Panel>
    </Collapse>
    <!--<el-dialog :visible.sync="transportQueue.show" title="传输列表" :mask-closable="false" :style="{bottom: '0px'}">-->
      <!--<List header="Header" footer="Footer" border size="small" :loading="transportQueue.loading" :split="false">-->
        <!--<ListItem>This is a piece of text.</ListItem>-->
        <!--<ListItem>This is a piece of text.</ListItem>-->
        <!--<ListItem>This is a piece of text.</ListItem>-->
      <!--</List>-->
    <!--</el-dialog>-->
    <Col span="12" style="height: 100%">
      <ServerFile ref="ServerFile" :tableHeight="tableHeight" :flag="true" v-on:syncServerToS3="syncServerToS3" v-on:serverToS3Cron="serverToS3Cron"></ServerFile>
    </Col>
     <Col span="12" style="height: 100%">
      <ServerFile ref="ServerFileTarget" :tableHeight="tableHeight" :flag="false"></ServerFile>
    </Col>
  </Row>
</template>

<script>
import { getFileLists, createDir, deleteFile, uploadFileUrl, downloadFile, getFileAcl,
  fileVersions, getBuckets, createBucket } from '@/api/s3/s3'
import { syncS3, editCronTransport, getTransportLogResult, syncDir, getAllTransportLogSyncList, getRateSyncthing } from '@/api/troop/troop'
import { valueTranUnit } from '@/libs/tools'
import moment from 'moment'
import folder3xPng from '@/assets/images/file-type/folder@3x.png'
import ServerFile from './server-file-sync'
import { getOpsCenterAllSupport } from '@/api/opscenter'

import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import wlTreeSelect from 'wl-vue-select'
import 'wl-vue-select/lib/wl-vue-select.css'
Vue.use(ElementUI)
Vue.use(wlTreeSelect)

export default {
  name: 'fileSync',
  components: {
    ServerFile
  },
  data () {
    return {
      currentPathTarget: '',
      allSupportList: [],
      tableHeight: 0,
      bucketTableHeight: 0,
      bucketData: [],
      bucketColumns: [
        {
          title: '桶名称',
          key: 'name',
          minWidth: 300,
          render: (h, params) => {
            return h('a', {
              on: {
                click: () => {
                  this.currentBucket = params.row.name
                  this.currentSupport = params.row.id
                  this.searchForm.path = ''
                  this.bucketsShow = false
                  this.getAllFolderList()
                  this.pathBtn('home')
                }
              }
            }, params.row.name)
          }
        },
        {
          title: '所属服务商',
          key: 'dec',
          minWidth: 300
        },
        {
          title: '创建时间',
          align: 'center',
          width: 300,
          resizable: true,
          render: (h, params) => {
            if (params.row.create_date) {
              return h('span', moment(params.row.create_date).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        }
      ],
      currentBucket: '',
      currentSupport: '',
      createBucket: {
        form: {
          bucket: '',
          id: ''
        },
        rules: {
          bucket: {required: true, message: '桶名称不能为空', trigger: 'blur'},
          id: {required: true, message: '服务商不能为空', trigger: 'blur', type: 'number'}
        },
        loading: false,
        modal: false
      },
      bucketsShow: true,
      listOrGrid: 'list',
      fade: {
        folder: false,
        upload: false,
        acl: false
      },
      load: {
        buckets: false,
        bucketCreating: false,
        deleteBtn: false,
        opeDirBtn: false,
        folder: false,
        upload: false,
        versionLoading: false,
        aclLoading: false
      },
      file_table_columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '名称',
          key: 'file_name',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            let fileP = h('span', params.row.file_name)
            if (this.isFolderFn(params.row)) {
              fileP = h('a', {
                on: {
                  click: () => {
                    this.routerPush(params.row)
                  }
                }
              }, params.row.file_name)
            }
            return h('div', [
              h('Avatar', {
                props: {
                  src: this.fileTypeIcon(params.row),
                  size: 'small'
                },
                style: {
                  marginRight: '10px'
                }
              }),
              fileP
            ])
          }
        },
        {
          title: '修改日期',
          align: 'center',
          width: 200,
          resizable: true,
          render: (h, params) => {
            if (params.row.last_modified) {
              return h('span', moment(params.row.last_modified).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '类型',
          align: 'center',
          resizable: true,
          width: 100,
          render: (h, params) => {
            return h('span', params.row.type === 'dir' ? '文件夹' : '文件')
          }
        },
        {
          title: '大小',
          key: 'size',
          align: 'center',
          width: 120,
          resizable: true,
          render: (h, params) => {
            if (params.row.size || params.row.size === 0) {
              return h('span', valueTranUnit(params.row.size, 2, 'B'))
            } else {
              return h('span', '-')
            }
          }
        }
      ],
      file_table_data: [],
      folder3xPng: folder3xPng,
      all_folder_list: [],
      folder_form: {
        file_name: '',
        preview: [],
        handle: []
      },
      folder_rules: {
        file_name: [{ required: true, message: '请填写文件夹名称', trigger: 'blur' }]
      },
      searchForm: {
        path: '',
        keyword: ''
      },
      selectData: [],
      path: {
        index: 0,
        history: [
          {
            path: ''
          }
        ]
      },
      uploadFileUrl: uploadFileUrl,
      uploadHeader: {
        Authorization: 'OPS ' + this.$store.state.user.token,
        DefaultTenant: this.$store.state.user.defaultTenant,
        SelTenants: this.$store.state.user.selTenants
      },
      versionData: [],
      versionColumns: [
        {
          title: '名称',
          key: 'file_name',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            return h('div', [
              h('Avatar', {
                props: {
                  src: this.fileTypeIcon(params.row),
                  size: 'small'
                },
                style: {
                  marginRight: '10px'
                }
              }),
              h('span', params.row.file_name)
            ])
          }
        },
        {
          title: '修改日期',
          align: 'center',
          width: 230,
          render: (h, params) => {
            if (params.row.last_modified) {
              return h('span', moment(params.row.last_modified).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '大小',
          minWidth: 90,
          key: 'size',
          align: 'center',
          width: 150,
          render: (h, params) => {
            if (params.row.size) {
              return h('span', valueTranUnit(params.row.size, 2, 'B'))
            } else {
              return ''
            }
          }
        },
        {
          title: '版本ID',
          align: 'center',
          key: 'version_id',
          width: 280
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 110,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '5px'
                },
                props: {
                  type: 'info',
                  size: 'small'
                },
                on: {
                  click: () => {
                    let file = this.selectData[0]
                    let data = {
                      name: file.prefix ? file.prefix + '/' + file.file_name : file.file_name,
                      bucket: this.currentBucket,
                      version_id: params.row.version_id,
                      id: this.currentSupport
                    }
                    downloadFile(data).then(res => {
                      this.download(res.data.data, file.file_name)
                    })
                  }
                }
              }, '下载')
            ])
          }
        }
      ],
      aclData: {},
      currentRClickRow: null,
      transportQueue: {
        show: true,
        loading: false,
        data: [],
        columns: [
          {
            title: '模式',
            key: 'model_verbose',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '源路径',
            key: 'source',
            align: 'center',
            tooltip: true,
            minWidth: 250
          },
          {
            title: '目标路径',
            key: 'target',
            align: 'center',
            tooltip: true,
            minWidth: 250
          },
          {
            title: '主机',
            key: 'hostname',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '传输开始时间',
            key: 'started',
            align: 'center',
            tooltip: true,
            minWidth: 180,
            render: (h, params) => {
              if (params.row.started) {
                return h('span', moment(params.row.started).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '传输结束时间',
            key: 'ended',
            align: 'center',
            tooltip: true,
            minWidth: 180,
            render: (h, params) => {
              if (params.row.ended) {
                return h('span', moment(params.row.ended).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            key: 'status',
            align: 'center',
            tooltip: true,
            minWidth: 60
          }
        ],
        queue: {},
        transporting: {},
        ended: {}
      },
      timer: null,
      moment: moment,
      message: {
        type: 'success',
        content: '',
        show: false
      },
      execHistoryResultErrMsg: '',
      execHistoryResultLoading: false,
      execHistoryResultModal: false,
      execHistoryResult: {}
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  created: function () {
    // this.getAllSupport()
    // this.getBucketsData()
    // if (this.currentBucket) {
    //   this.getAllFolderList()
    //   this.getFileList()
    // }
    this.history()
    // let currentS3FileViewMode = sessionStorage.getItem('currentS3FileViewMode')
    // if (currentS3FileViewMode) {
    //   this.listOrGrid = currentS3FileViewMode
    // }
    this.setTimer()
  },
  mounted () {
    this.tableHeight = window.innerHeight - 270
    this.bucketTableHeight = window.innerHeight - 270
    window.onresize = () => {
      return (() => {
        this.tableHeight = window.innerHeight - 270
        this.bucketTableHeight = window.innerHeight - 270
      })()
    }
  },
  watch: {
    listOrGrid () {
      sessionStorage.setItem('currentS3FileViewMode', this.listOrGrid)
    }
  },
  methods: {
    // 获取所有服务商
    getAllSupport () {
      getOpsCenterAllSupport({type: 9}).then(res => {
        this.allSupportList = res.data
      })
    },
    // 获取桶数据
    getBucketsData () {
      this.load.buckets = true
      getBuckets().then(res => {
        this.load.buckets = false
        this.bucketData = res.data.data
      }).catch(res => {
        this.load.buckets = false
        console.error(res.response)
      })
    },
    changeBucket () {
      this.bucketsShow = true
      this.currentBucket = ''
      this.file_table_data = []
    },
    // 判断是否文件夹函数
    isFolderFn (row) {
      return row.type === 'dir'
    },
    // 获取文件夹列表
    getFileList (prefix = this.searchForm.path, newPath = true) {
      let params = {
        bucket: this.currentBucket,
        prefix: prefix,
        id: this.currentSupport
      }
      if (newPath && prefix !== this.searchForm.path) {
        this.path.history.push({
          path: prefix
        })
        this.path.index += 1
      }
      let oldPath = this.currentPath
      this.load.folder = true
      getFileLists(params).then(res => {
        this.selectData = []
        this.load.folder = false
        this.file_table_data = res.data.data.files || []
        this.searchForm.path = res.data.data.prefix
      }).catch(res => {
        this.searchForm.path = oldPath
        this.load.folder = false
        console.log(res.response)
        this.$message.error(res.response.data.error)
      })
    },
    // 获取文件夹列表
    getAllFolderList () {
      // let params = {
      //   bucket: this.currentBucket,
      //   prefix: ''
      // }
      // getAllDirLists(params).then(res => {
      //   this.all_folder_list = res.data.data.files || []
      // })
    },
    // 根据文件类型显示图标
    fileTypeIcon (row) {
      let _path = ''
      // 文件夹
      if (this.isFolderFn(row)) {
        _path = require('@/assets/images/file-type/folder@3x.png')
        return _path
      }
      let fileNameSplit = row['file_name'].split('.')
      // 其他根据后缀类型
      let _suffix = fileNameSplit[fileNameSplit.length - 1]
      if (!_suffix) {
        _path = require('@/assets/images/file-type/file_none@3x.png')
        return _path
      }
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_img@3x.png')
      } else if (['zip', 'rar', '7z'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_zip@3x.png')
      } else if (['avi', 'mp4', 'rmvb', 'flv', 'mov', 'm2v', 'mkv'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_video@3x.png')
      } else if (['mp3', 'wav', 'wmv', 'wma'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_mp3@3x.png')
      } else if (['xls', 'xlsx'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_excel@3x.png')
      } else if (['doc', 'docx'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_pdf@3x.png')
      } else if (_suffix === 'pdf') {
        _path = require('@/assets/images/file-type/file_docx@3x.png')
      } else if (_suffix === 'ppt') {
        _path = require('@/assets/images/file-type/file_ppt@3x.png')
      } else if (_suffix === 'txt') {
        _path = require('@/assets/images/file-type/file_txt@3x.png')
      } else {
        _path = require('@/assets/images/file-type/file_none@3x.png')
      }
      return _path
    },
    submitFolderFrom () {
      let data = {
        bucket: this.currentBucket,
        prefix: this.searchForm.path,
        name: this.folder_form.file_name,
        id: this.currentSupport
      }
      this.load.opeDirBtn = true
      createDir(data).then(res => {
        this.load.opeDirBtn = false
        this.fade.folder = false
        this.pathBtn('refresh')
        this.$message.success('创建文件夹成功')
      }).catch(res => {
        this.load.opeDirBtn = false
        if (res.response) {
          this.$message.error(res.response.data)
        } else {
          this.$message.error('创建文件夹失败')
        }
      })
    },
    handleChange (selectRow) {
      this.selectData = selectRow
    },
    routerPush (row) {
      let path = row.file_name
      if (row.prefix) {
        path = `${row.prefix}/${path}`
      }
      this.path.history = this.path.history.slice(0, this.path.index + 1)
      this.getFileList(path)
    },
    deleteSubmit () {
      this.$Modal.confirm({
        title: '删除文件/文件夹',
        content: '<p style="color: red">注意！删除文件夹将同时删除文件夹内的所有文件</p>',
        loading: true,
        onOk: () => {
          let data = {
            prefix: this.searchForm.path,
            bucket: this.currentBucket,
            data: [],
            id: this.currentSupport
          }
          for (let i in this.selectData) {
            data.data.push({
              name: this.selectData[i].file_name,
              type: this.selectData[i].type
            })
          }
          this.load.deleteBtn = true
          deleteFile(data).then(res => {
            this.$Modal.remove()
            this.load.deleteBtn = false
            this.pathBtn('refresh')
            this.$message.success('删除成功')
          }).catch(res => {
            this.$Modal.remove()
            this.load.deleteBtn = false
            if (res.response) {
              this.$message.error(res.response.data)
            } else {
              this.$message.error('删除失败')
            }
            console.error(res.response)
          })
        }
      })
    },
    // 当前是否最后一步
    pathIsEnd () {
      return this.path.index >= this.path.history.length - 1
    },
    // 当前是否第一步
    pathIsStart () {
      return this.path.index <= 0
    },
    // 前进后退刷新根目录按钮操作
    pathBtn (type) {
      if (type === 'prv') {
        if (this.pathIsStart()) return
        this.path.index -= 1
        this.getFileList(this.path.history[this.path.index].path, false)
      } else if (type === 'next') {
        if (this.pathIsEnd()) return
        this.path.index += 1
        this.getFileList(this.path.history[this.path.index].path, false)
      } else if (type === 'home') {
        this.path = {
          index: 0,
          history: [
            {
              path: ''
            }
          ]
        }
        this.getFileList('', false)
      } else if (type === 'top') {
        let pArr = this.searchForm.path.split('/')
        if (pArr.length === 0 || (pArr.length === 1 && pArr[0] === '')) return
        pArr.pop(1)
        this.path.index += 1
        this.getFileList(pArr.join('/'), false)
      } else {
        this.getFileList(this.searchForm.path, false)
      }
    },
    moreAction (name) {
      if (this.selectData.length <= 0) return
      let file = this.selectData[0]
      if (file.type === 'dir') {
        this.$message.warning('暂不支持操作文件夹')
        return
      }
      switch (name) {
        case ('move'):
          break
        case ('download'):
          let data = {
            name: file.prefix ? file.prefix + '/' + file.file_name : file.file_name,
            bucket: this.currentBucket,
            id: this.currentSupport
          }
          downloadFile(data).then(res => {
            this.download(res.data.data, file.file_name)
          })
          break
        case ('acl'):
          this.getAcl(file)
          break
        case ('version'):
          this.getVersions(file)
          break
      }
    },
    download (url, fileName) {
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    maxSize () {
      this.$message.warning({ title: '文件太大, 限制最大512M' })
    },
    handleFileSuccess (res, file) {
      this.fade.upload = false
      this.load.upload = false
      this.pathBtn('refresh')
      this.$message.success('上传成功')
    },
    handleFileError (res, errMsg) {
      this.load.upload = false
      if (errMsg) {
        this.$message.error(errMsg)
      } else {
        this.$message.error('上传失败')
      }
    },
    getVersions (row) {
      let params = {
        bucket: this.currentBucket,
        name: row.prefix ? row.prefix + '/' + row.file_name : row.file_name,
        id: this.currentSupport
      }
      this.load.versionLoading = true
      this.fade.version = true
      fileVersions(params).then(res => {
        this.load.versionLoading = false
        this.versionData = res.data.data
      }).catch(res => {
        this.load.versionLoading = false
        console.error(res.response)
      })
    },
    getAcl (row) {
      let params = {
        bucket: this.currentBucket,
        name: row.file_name,
        id: this.currentSupport
      }
      this.load.aclLoading = true
      this.fade.acl = true
      getFileAcl(params).then(res => {
        this.load.aclLoading = false
        this.aclData = res.data.data
      }).catch(res => {
        this.load.aclLoading = false
        console.error(res.response)
      })
    },
    gridClick (item, idx) {
      this.file_table_data[idx]._checked = !this.file_table_data[idx]._checked
      this.gridItemCheck(this.file_table_data[idx]._checked, item, idx)
    },
    gridItemCheck (c, item, idx) {
      this.$refs.backup_file_table.objData[idx]._isChecked = c
      this.$nextTick(function () {
        this.handleChange(this.$refs.backup_file_table.getSelection())
      })
    },
    tableDblClick (item) {
      if (item.type === 'dir') {
        this.routerPush(item)
      }
    },
    selectRow (selection, row) {
      for (let i in this.file_table_data) {
        if (this.file_table_data[i].file_name === row.file_name) {
          this.file_table_data[i]._checked = true
        }
      }
    },
    selectRowCancel (selection, row) {
      for (let i in this.file_table_data) {
        if (this.file_table_data[i].file_name === row.file_name) {
          this.file_table_data[i]._checked = false
        }
      }
    },
    selectAll () {
      for (let i in this.file_table_data) {
        this.file_table_data[i]._checked = true
      }
    },
    selectAllCancel () {
      for (let i in this.file_table_data) {
        this.file_table_data[i]._checked = false
      }
    },
    // 用通道agent 直接覆盖更新配置文件写法
    syncServerToS3 (hostname, source, name, isDir, os, ip, checked) {
      console.log(hostname)
      console.log(os)
      let params = {
        checked: checked,
        source_hostname: hostname,
        target_hostname: this.$refs.ServerFileTarget.currentServer,
        source_os: os,
        target_os: this.$refs.ServerFileTarget.currentServerOs,
        source_ip: ip,
        target_ip: this.$refs.ServerFileTarget.currentServerIp,
        source_path: source,
        target_path: `${this.$refs.ServerFileTarget.currentPath}/${name}`,
        file_name: name
      }
      syncDir(params).then(res => {
        this.transportQueue.show = 'transport_list'
        this.history()
        this.showMessage('success', '传输任务已加入队列')
      }).catch(res => {
        console.error(res.response)
      })
    },
    // 调用 syncthing  api 的写法
    // syncServerToS3 (hostname, source, name, isDir) {
    //   console.log(source)
    //   // 调用 Syncthing  api 同步到目标服务器
    //   const syncthing = require('node-syncthing')
    //   // Options
    //   const options = {
    //     host: '10.1.2.175',
    //     port: 8384,
    //     apiKey: 'bzHYbHzdUgC5P965b3YyDtZyC7EvF6Ke',
    //     eventListener: true,
    //     retries: 10,
    //     https: false
    //   }
    //   const st = syncthing(options)
    //   st.system.ping((err, res) => {
    //     if (!err) {
    //       // ping 通后才进行 调用
    //       st.system.getConfig().then(res => {
    //         // 判断是否配置里面有目标主机名，没有则添加进去即可
    //         if (res['devices'].filter(item => item.name === 'opsdeep-2').length === 0) {
    //           res['devices'].push({
    //             addresses: ['dynamic'],
    //             allowedNetworks: [],
    //             autoAcceptFolders: false,
    //             certName: '',
    //             compression: 'metadata',
    //             deviceID: 'OP5NLKS-ECDIPMK-BUKAWM5-YDBN2TW-DWQ4TDM-CYFSPUY-BY3W77T-RWITKQV',
    //             ignoredFolders: [],
    //             introducedBy: '',
    //             introducer: false,
    //             maxRecvKbps: 0,
    //             maxRequestKiB: 0,
    //             maxSendKbps: 0,
    //             name: 'opsdeep-2',
    //             paused: false,
    //             pendingFolders: [],
    //             skipIntroductionRemovals: false
    //           })
    //         }
    //         if (res['folders'].filter(item => item.id === name).length === 0) {
    //           res['folders'].push({
    //             'id': name,
    //             'label': name,
    //             'filesystemType': 'basic',
    //             'path': source,
    //             'type': 'sendreceive',
    //             'devices': [
    //               {
    //                 'deviceID': 'OGN4U4G-SFCTUF6-N6BTMDF-6VPZSTW-BU2OI3E-HPXZDU6-IL54SYX-3Y3DUAA',
    //                 'introducedBy': ''
    //               },
    //               {
    //                 'deviceID': 'OP5NLKS-ECDIPMK-BUKAWM5-YDBN2TW-DWQ4TDM-CYFSPUY-BY3W77T-RWITKQV',
    //                 'introducedBy': ''
    //               }
    //             ],
    //             'rescanIntervalS': 3600,
    //             'fsWatcherEnabled': true,
    //             'fsWatcherDelayS': 10,
    //             'ignorePerms': false,
    //             'autoNormalize': true,
    //             'minDiskFree': {
    //               'value': 1,
    //               'unit': '%'
    //             },
    //             'versioning': {
    //               'type': '',
    //               'params': {}
    //             },
    //             'copiers': 0,
    //             'pullerMaxPendingKiB': 0,
    //             'hashers': 0,
    //             'order': 'random',
    //             'ignoreDelete': false,
    //             'scanProgressIntervalS': 0,
    //             'pullerPauseS': 0,
    //             'maxConflicts': 10,
    //             'disableSparseFiles': false,
    //             'disableTempIndexes': false,
    //             'paused': false,
    //             'weakHashThresholdPct': 25,
    //             'markerName': '.stfolder',
    //             'copyOwnershipFromParent': false,
    //             'modTimeWindowS': 0,
    //             'maxConcurrentWrites': 0,
    //             'disableFsync': false,
    //             'blockPullOrder': 'standard'
    //           })
    //         }
    //         console.log(res)
    //         st.system.setConfig(res).then(res => {
    //           let sourceTarget = `${this.$refs.ServerFileTarget.currentPath}/${name}`
    //           console.log(sourceTarget)
    //           // 源机器设置成功后，设置目标机器即可
    //           const options = {
    //             host: '10.1.2.176',
    //             port: 8384,
    //             apiKey: 'fCqCRU2RmjGeF2t2RzNdjGavgp3gL5rj',
    //             eventListener: true,
    //             retries: 10,
    //             https: false
    //           }
    //           const st = syncthing(options)
    //           st.system.ping((err, res) => {
    //             if (!err) {
    //               // ping 通后才进行 调用
    //               st.system.getConfig().then(res => {
    //                 // 判断是否配置里面有目标主机名，没有则添加进去即可
    //                 if (res['devices'].filter(item => item.name === 'opsdeep-1').length === 0) {
    //                   res['devices'].push({
    //                     addresses: ['dynamic'],
    //                     allowedNetworks: [],
    //                     autoAcceptFolders: false,
    //                     certName: '',
    //                     compression: 'metadata',
    //                     deviceID: 'OGN4U4G-SFCTUF6-N6BTMDF-6VPZSTW-BU2OI3E-HPXZDU6-IL54SYX-3Y3DUAA',
    //                     ignoredFolders: [],
    //                     introducedBy: '',
    //                     introducer: false,
    //                     maxRecvKbps: 0,
    //                     maxRequestKiB: 0,
    //                     maxSendKbps: 0,
    //                     name: 'opsdeep-1',
    //                     paused: false,
    //                     pendingFolders: [],
    //                     skipIntroductionRemovals: false
    //                   })
    //                 }
    //                 if (res['folders'].filter(item => item.id === name).length === 0) {
    //                   res['folders'].push({
    //                     'id': name,
    //                     'label': name,
    //                     'filesystemType': 'basic',
    //                     'path': sourceTarget,
    //                     'type': 'sendreceive',
    //                     'devices': [
    //                       {
    //                         'deviceID': 'OGN4U4G-SFCTUF6-N6BTMDF-6VPZSTW-BU2OI3E-HPXZDU6-IL54SYX-3Y3DUAA',
    //                         'introducedBy': ''
    //                       },
    //                       {
    //                         'deviceID': 'OP5NLKS-ECDIPMK-BUKAWM5-YDBN2TW-DWQ4TDM-CYFSPUY-BY3W77T-RWITKQV',
    //                         'introducedBy': ''
    //                       }
    //                     ],
    //                     'rescanIntervalS': 3600,
    //                     'fsWatcherEnabled': true,
    //                     'fsWatcherDelayS': 10,
    //                     'ignorePerms': false,
    //                     'autoNormalize': true,
    //                     'minDiskFree': {
    //                       'value': 1,
    //                       'unit': '%'
    //                     },
    //                     'versioning': {
    //                       'type': '',
    //                       'params': {}
    //                     },
    //                     'copiers': 0,
    //                     'pullerMaxPendingKiB': 0,
    //                     'hashers': 0,
    //                     'order': 'random',
    //                     'ignoreDelete': false,
    //                     'scanProgressIntervalS': 0,
    //                     'pullerPauseS': 0,
    //                     'maxConflicts': 10,
    //                     'disableSparseFiles': false,
    //                     'disableTempIndexes': false,
    //                     'paused': false,
    //                     'weakHashThresholdPct': 25,
    //                     'markerName': '.stfolder',
    //                     'copyOwnershipFromParent': false,
    //                     'modTimeWindowS': 0,
    //                     'maxConcurrentWrites': 0,
    //                     'disableFsync': false,
    //                     'blockPullOrder': 'standard'
    //                   })
    //                 }
    //                 console.log(res)
    //                 st.system.setConfig(res).then(res => {
    //                   console.log(res)
    //                 })
    //               })
    //             }
    //           })
    //         })
    //       })
    //     } else {
    //       console.error(err)
    //     }
    //   })
    // },
    serverToS3Cron (hostname, source, name, isDir) {
      if (this.bucketsShow) {
        this.$message.error('请选择桶')
        return
      }
      let path = this.searchForm.path
      if (path) {
        path = path + '/'
      }
      if (isDir) {
        path = path + name + '/'
      }
      let data = {
        desc: `${this.$refs.ServerFile.currentServer}_to_${this.currentBucket}`,
        hostname: hostname,
        source: source,
        model: 'server_to_storage',
        target: `s3://${this.currentBucket}/${path}`,
        support: this.currentSupport
      }
      editCronTransport(data).then(res => {
        this.showMessage('success', '传输任务已加入计划')
      }).catch(res => {
        console.error(res.response)
        this.showMessage('error', '操作失败')
      })
    },
    syncS3ToServer (row) {
      if (this.bucketsShow || !this.currentBucket) {
        this.$message.error('请选择桶')
        return
      }
      if (!this.$refs.ServerFile.currentServer) {
        this.$message.error('请选择服务器')
        return
      }
      let s3Path = row.prefix + '/' + row.file_name
      let serverPath = this.$refs.ServerFile.currentPath + this.$refs.ServerFile.separator + row.file_name
      if (this.isFolderFn(row)) {
        s3Path = s3Path + '/'
        serverPath = serverPath + this.$refs.ServerFile.separator
      }
      let sourcePath = `s3://${this.currentBucket}${s3Path}`
      if (!this.currentBucket.endsWith('/') && !s3Path.startsWith('/')) {
        sourcePath = `s3://${this.currentBucket}/${s3Path}`
      }

      let data = {
        hostname: this.$refs.ServerFile.currentServer,
        model: 'storage_to_server',
        source: sourcePath,
        target: serverPath,
        support: this.currentSupport
      }
      syncS3(data).then(res => {
        this.transportQueue.show = 'transport_list'
        this.history()
        this.$refs.ServerFile.pathBtn('refresh')
        this.showMessage('success', '传输任务已加入队列')
      }).catch(res => {
        console.error(res.response)
        this.showMessage('error', '操作失败')
      })
    },
    s3SendToServerCron (row) {
      if (this.bucketsShow || !this.currentBucket) {
        this.$message.error('请选择桶')
        return
      }
      if (!this.$refs.ServerFile.currentServer) {
        this.$message.error('请选择服务器')
        return
      }
      let s3Path = row.prefix + '/' + row.file_name
      let serverPath = this.$refs.ServerFile.currentPath + '/' + row.file_name
      if (this.isFolderFn(row)) {
        s3Path = s3Path + '/'
        serverPath = serverPath + '/'
      }
      let data = {
        desc: `${this.currentBucket}_to_${this.$refs.ServerFile.currentServer}`,
        hostname: this.$refs.ServerFile.currentServer,
        model: 'storage_to_server',
        source: `s3://${this.currentBucket}${s3Path}`,
        target: serverPath,
        support: this.currentSupport
      }
      editCronTransport(data).then(res => {
        this.showMessage('success', '传输任务已加入计划')
      }).catch(res => {
        console.error(res.response)
        this.showMessage('error', '操作失败')
      })
    },
    historyArray () {
      let h = []
      for (let i in this.path.history) {
        if (h.indexOf(this.path.history[i].path) === -1) {
          h.push(this.path.history[i].path)
        }
      }
      return h
    },
    pathSelect (val) {
      this.getFileList(val.value)
    },
    rMenuClick (name) {
      switch (name) {
        case 'prv':
        case 'next':
        case 'refresh':
          this.pathBtn(name)
          break
        case 'tran':
          this.syncS3ToServer(this.currentRClickRow)
          break
      }
      this.hideRMenu()
    },
    divRight (event) {
      this.rowRightClick(null, event)
    },
    rowRightClick (row, event) {
      this.currentRClickRow = row
      this.showRMenu(event.clientX, event.clientY)
    },
    showRMenu (x, y) {
      $('#s3-file-row-rMenu ul').show()
      $('#s3-file-row-rMenu').css({ 'top': y - 60 + 'px', 'left': x - 250 + 'px', 'visibility': 'visible' })
      $('body').bind('mousedown', this.onBodyMouseDown)
    },
    hideRMenu () {
      this.currentRClickRow = null
      if ($('#s3-file-row-rMenu')) $('#s3-file-row-rMenu').css({ 'visibility': 'hidden' })
      $('body').unbind('mousedown', this.onBodyMouseDown)
    },
    onBodyMouseDown (event) {
      if (!(event.target.id === 'rMenu' || $(event.target).parents('#s3-file-row-rMenu').length > 0)) {
        $('#s3-file-row-rMenu').css({ 'visibility': 'hidden' })
      }
    },
    rowClassName (row, idx) {
      if (this.currentRClickRow && row.file_name === this.currentRClickRow.file_name) {
        return 'ivu-table-row-highlight'
      }
      return ''
    },
    history (loading) {
      let params = {
        execute_user: this.$store.state.user.userId,
        model: 'server_to_server'
      }
      this.transportQueue.loading = loading
      getAllTransportLogSyncList(params).then(res => {
        this.transportQueue.loading = false
        this.transportQueue.data = res.data
        for (let i in res.data) {
          let data = res.data[i]
          if (data.status === '传输中') {
            this.transportQueue.transporting[data.id] = data
            delete (this.transportQueue.queue[data.id])
            this.getTransportRate(data.id)
          } else if (data.status === '队列中') {
            this.transportQueue.queue[data.id] = data
          } else if (data.status === '完成') {
            if (data.id in this.transportQueue.queue || data.id in this.transportQueue.transporting) {
              this.showMessage('success', `队列[${data.id}]传输完成`)
              this.transportQueue.ended[data.id] = data
              delete (this.transportQueue.queue[data.id])
              delete (this.transportQueue.transporting[data.id])
              this.$refs.ServerFileTarget.pathBtn('refresh')
            }
          }
        }
      }).catch(res => {
        this.transportQueue.loading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取列表失败！服务器无响应'
          })
        }
      })
    },
    getTransportRate () {
      let params = {
        execute_user: this.$store.state.user.userId
      }
      getRateSyncthing(params).then(res => {
      })
    },
    // 自动刷新
    setTimer () {
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.history(false)
          this.getTransportRate()
        }, 20000)
      }
    },
    showMessage (type, content) {
      this.message.type = type
      this.message.content = content
      this.message.show = true
    },
    createBucketOpen () {
      this.createBucket.form.bucket = ''
      this.createBucket.modal = true
    },
    createBucketOk () {
      this.$refs['createBucketForm'].validate((valid) => {
        if (valid) {
          this.createBucket.loading = true
          createBucket(this.createBucket.form).then(res => {
            if (res.data.code === 200) {
              this.createBucket.modal = false
              this.createBucket.loading = false
              this.createBucket.form.bucket = ''
              this.createBucket.form.id = ''
              this.$message.success('创建成功')
              this.getBucketsData()
            } else {
              this.createBucket.loading = false
              this.$message.error(`创建失败, ${res.data.msg}`)
              console.error(res.data.msg)
            }
          }).catch(res => {
            this.createBucket.loading = false
            this.$message.error('创建失败')
            console.error(res.response)
          })
        }
      })
    },
    openResultModal (id) {
      this.execHistoryResultErrMsg = ''
      this.execHistoryResultLoading = true
      this.execHistoryResultModal = true
      getTransportLogResult(id).then(res => {
        this.execHistoryResultLoading = false
        this.execHistoryResult = res.data.result
      }).catch(res => {
        this.execHistoryResultLoading = false
        this.execHistoryResultErrMsg = '数据获取失败'
      })
    }
  }
}
</script>

<style lang="less">
  @import '../base.less';
  .backup-manage-index {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .file-path-img{
    margin-top:6px;
    vertical-align:top
  }
  .file-action-btn {
    margin-right: 10px;
  }
  .backup_file_table,
  .backup_file_table th,
  .backup_file_table td {
    border-color: #EBEEF5;
  }
  .backup_file_table .ivu-table-row {
    font-size: 14px;
  }
  .backup_file_table th {
    background-color: #F9F9F9;
  }
  .u-disabled {
    color: #dedada;
    cursor: no-drop;
  }
  .file-handle-box .active {
    cursor: pointer;
    color: #929292;
  }
  .main-bucket {
    padding-bottom: 10px;
  }

  .wl-is-folder {
    cursor: pointer;
    &:hover {
      color: #409EFF;
    }
  }
  // 主体文件列表区
  .wl-main-list {
    padding: 0 20px 20px;
  }
  .wl-list {
    overflow: hidden;
    text-align: center;
    overflow-y: auto;
    .wl-list-item {
      list-style-type:none;
      position: relative;
      float: left;
      padding: 12px;
      width: 94px;
      &:hover .wl-checkbox {
        display: inline-block;
      }
    }
    .wl-checkbox-selected {
      display: inline-block !important;
    }
    .wl-checkbox {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
    }
    .name-col-icon {
      width: 66px;
      height: 66px;
    }
    .list-item-name {
      height: 40px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-size: 12px;
    }
  }
  .transport-list-collapse {
    margin: 8px;
    border: 0;
    .ivu-progress {
      margin-bottom: 0 !important;
    }
  }
  .transport-list-divider {
    margin: 0 15px
  }
  .exec-history-result {
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
  }
</style>
